<template>
  <div class="flex flex-col bg-white rounded-lg border border-gray-100 shadow-sm mt-4">
    <div class="flex flex-col sm:flex-row justify-between gap-3 border-b border-gray-100 p-4 sm:p-5 items-start sm:items-center">
    <h1 class="text-base sm:text-lg text-gray-900 font-semibold">To be Decommissioned</h1>
    <button class="rounded-lg px-4 py-2 bg-express text-white text-sm font-medium hover:bg-expressbutton transition-colors">Download</button>
    </div>
<div class="w-full overflow-x-auto p-4 sm:p-5">
<table class="w-full text-sm">
  <thead>
  <tr class="border-b border-gray-200 text-left">
    <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Business Name</th>
    <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Location</th>
    <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Telephone</th>
    <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">RDE-Personnel</th>
    <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Date</th>
    <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Status</th>
    <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Update</th>
  </tr>
  </thead>
  <tbody>
  <tr class="border-b border-gray-100 hover:bg-gray-50" v-for="(item,index) in decommission_list.data" :key="index">
    <td class="px-3 py-3 whitespace-nowrap">{{item.business_name}}</td>
    <td class="px-3 py-3 whitespace-nowrap">{{item.address}}</td>
    <td class="px-3 py-3 whitespace-nowrap">{{item.phone}}</td>
    <td class="px-3 py-3 whitespace-nowrap">{{item.rde_personnel}}</td>
    <td class="px-3 py-3 whitespace-nowrap">{{item.created_at}}</td>
    <td class="px-3 py-3 whitespace-nowrap">{{item.status}}</td>
    <td class="px-3 py-3 whitespace-nowrap"><button class="disabled border border-gray-200 rounded-lg px-3 py-1.5 text-xs font-medium text-expressgray hover:bg-gray-50 transition-colors">Update Status</button></td>
  </tr>
  </tbody>
    </table>
</div>


  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
 name: "Decommissioned",
  created(){
    this.$store.dispatch('admins/action_decommission_list',{
      toast:this.$toast,
      router:this.$router
    });


  },
  computed:{
    ...mapGetters({
      decommission_list: 'admins/decommission_list'
    }),
  },
}
</script>


<style>

</style>
